/**
 * Which node or link of the editor's canvas shows its detail card: the one
 * the pointer rests on or the keyboard is on, by its canvas id (`first`, a
 * step's name, or a link's `from→to`), and a node's card, built by the
 * canvas, which holds the draft and the schemas. The editor's canvas
 * provides it; a run's canvas does not, so its nodes and links never open a
 * card.
 */
import { createContext, useContext } from 'react';

import type { NodeCard } from './node-card.js';

export interface Hovered {
  id: string | null;
  /** The hovered node's card; null on a link. */
  card: NodeCard | null;
}

export const HoveredContext = createContext<Hovered>({ id: null, card: null });

/** Whether the node or link with this canvas id shows its card. */
export function useHovered(id: string): boolean {
  return useContext(HoveredContext).id === id;
}

/** The card of the node with this canvas id while it shows, else null. */
export function useNodeCard(id: string): NodeCard | null {
  const hovered = useContext(HoveredContext);
  return hovered.id === id ? hovered.card : null;
}
